class Toggle {
    constructor(toggles, lists, mobileOnly) {
        this.toggles = toggles
        this.lists = lists
        this.mobileOnly = mobileOnly
        this.checkResponsive()
    }
    handleToggles(i) {
        if (this.lists[i].style.maxHeight) {
            this.lists[i].setAttribute('aria-hidden', true);
            this.lists[i].style.maxHeight = null;
        } else {
            this.lists[i].setAttribute('aria-hidden', false);
            this.lists[i].style.maxHeight = `${this.lists[i].scrollHeight}px` 
        }
    }
    openLists(i) {
        this.lists[i].setAttribute('aria-hidden', false);
        this.toggles[i].classList.add('footer__tab--active');   
        this.lists[i].style.maxHeight = `${this.lists[i].scrollHeight}px` 
    }
    closeLists(i) {
        this.lists[i].setAttribute('aria-hidden', true);
        this.toggles[i].classList.remove('footer__tab--active'); 
        this.lists[i].style.maxHeight = null;
    }
    checkResponsive() {
        this.toggles.forEach((toggle, i) => {
            if (this.mobileOnly) { 
                if (window.innerWidth <= 800) {   
                    this.closeLists(i)
                } else {
                    this.openLists(i)
                }
            }
            window.addEventListener('resize', (e) => {
                if (this.mobileOnly) { 
                    if (window.innerWidth <= 800) {   
                        this.closeLists(i)
                    } else {
                        this.openLists(i)
                    }
                }
            })
            toggle.addEventListener('click', () => {
                if (this.mobileOnly) {
                    if (window.innerWidth <= 800) {
                        toggle.classList.toggle('footer__tab--active');   
                        this.handleToggles(i)
                    }
                } else {
                    this.handleToggles(i)
                }
            })
        })
    }
}

export default Toggle